import React from "react";
import "./ShowTextFile.css";

function ShowTextFile(props) {
  const { file, removeFile } = props;
  return (
    <div className="thumb-file">
      <div className="row center-box position-relative">
        <div className="col-11">
          <div className="thumbInner">
            {file?.file?.src && file?.file?.type == 'video/mp4'?
              <a href={file?.file?.src} target="_blank">{file?.file?.src}</a>
              :
              <span>{file.name?? file?.file?.name??''}</span>
            }
          </div>
        </div>
        <div className="col-1 position-static">
          <button className="remove-file" onClick={() => removeFile(file.id)}>
            <img
              src="assets/icons/ic-add.png"
              alt="ExportFiles Icon"
              className="ic-remove-img"
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShowTextFile;
